module.exports = __webpack_public_path__ + "img/normal_multiplier_3.0138e349.png";